import React from "react";

export default function SideBox(props) {
	return (
		<>
			<div className="col sidebox">
				<div className="inner-sidebox">
					<p>This box is a placeholder for actual content</p>
				</div>
			</div>
		</>
	);
}
